import { Injectable } from "@angular/core";

@Injectable()
export class ConstantService {
  //serverUrlConstant = 'http://10.10.14.87:8081/cmsopencontrolpanel/';

  //serverUrlConstant= 'http://103.94.136.54/anandmediacontrolpanel/';

  serverUrlConstant = "http://10.10.14.64:8080/";
  //production
  //  serverUrlConstant = 'http://anandmedialive.cinesoftcdn.com:8086/anandmediacontrolpanel/';
}



// WEBPACK FOOTER //
// ./src/app/shared/constant/constant.service.ts